








































































import Vue from 'vue'
import Component from 'vue-class-component'
import ReleaseChange, {ChangeType} from '@/modules/app-router/model/ReleaseChange'
import {Prop} from 'vue-property-decorator'
import {State} from 'vuex-class'
import {VForm} from '@/types'
import App from '@/modules/app-router/model/App'

/**
 * Edición de un cambio realizado a una distribución
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ChangeDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: VForm,
    }

    /**
     * Controla la visibilidad del componente
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Cambio actualmente seleccionado por el usuario
     *
     * @var { ReleaseChange }
     */
    @State(state => state.appRouter.currentChange)
    public change: ReleaseChange

    /**
     * Aplicación actualmente seleccionada por el usuario
     *
     * @var { App }
     */
    @State(state => state.appRouter.app)
    public app: App

    /**
     * Indica si el formulario es válido y ha pasado todas las validaciones
     */
    public valid = true

    /**
     * Reglas de validación para los campos
     */
    public validationRules: { [key: string]: Array<(value: any) => true | string> } = {
        type: [
            v => !!v || 'El tipo de cambio es obligatorio',
        ],
        title: [
            v => !!v || 'El título del cambio es obligatorio',
            v => v.length <= 120 || 'El título del cambio no puede superar los 120 caracteres',
        ],
    }

    public changeTypes = [
        {
            type: ChangeType.Added,
            text: 'El cambio añade nuevas funcionalidades',
            color: 'green',
            icon: 'mdi-plus-outline',
        },
        {
            type: ChangeType.Changed,
            text: 'El cambio modifica funcionalidades existentes',
            color: 'blue',
            icon: 'mdi-transition',
        },
        {
            type: ChangeType.Deprecated,
            text: 'El cambio marca una funcionalidad como obsoleta',
            color: 'yellow darken-3',
            icon: 'mdi-alert',
        },
        {type: ChangeType.Removed, text: 'El cambio elimina una funcionalidad', color: 'red', icon: 'mdi-minus'},
        {
            type: ChangeType.Security,
            text: 'El cambio corrige un fallo grave de seguridad',
            color: 'orange darken-3',
            icon: 'mdi-security',
        },
        {
            type: ChangeType.Fixed,
            text: 'El cambio corrige una funcionalidad',
            color: 'pink darken-3',
            icon: 'mdi-cog-outline',
        },
    ]

    /**
     * Actualiza un campo del cambio actualmente seleccionado por el usuario.
     *
     * @param field Nombre del campo
     * @param value Valor del campo
     */
    public update (field: string, value: any) {
        this.$store.commit('appRouter/UPDATE_CHANGE_FIELD', {field, value})
    }

    /**
     * Guarda las modificaciones realizadas al cambio actualmente en edición
     */
    public save () {
        this.$store.commit('appRouter/ADD_CHANGE', this.change)
        this.$emit('input', false)
    }
}
